module.exports = __webpack_public_path__ + "img/monkey.f0a01496.png";